import React from "react";
import yashhealthimg from "../assets/yashhealthimg.png";
import yashskills from "../assets/yashskills.png";
import wittyimg from "../assets/wittyhack.png";
import wittyskills from "../assets/wittyskills.png";
import krishiimg from "../assets/krishimitra.png";
import ietconnectimg from "../assets/ietconectlandscape.png";

const Project = () => {
  // Project data array
  const projects = [
    {
      id: 4,
      title: "IET Connect App",
      description: "One app for IET-DAVV students",
      skillsImage: wittyskills,
      projectImage: ietconnectimg,
      skillsImageStyle: "h-12",
      link: "https://iet-connect.vercel.app/",
      detaildescription: "",
    },
    {
      id: 3,
      title: "YashHealth",
      description: "your health companion",
      skillsImage: yashskills,
      projectImage: yashhealthimg,
      skillsImageStyle: "h-12",
      link: "https://yashhealth.vercel.app/",
    },
    {
      id: 2,
      title: "Krishi Mitra",
      description: "Empowering Farmers of India",
      skillsImage: yashskills,
      projectImage: krishiimg,
      skillsImageStyle: "h-12",
    },
    {
      id: 1,
      title: "E-Commerce",
      description: "one stop for all clothing need",
      skillsImage: wittyskills,
      projectImage: wittyimg,
      skillsImageStyle: "h-14 pl-4",
    },
  ];

  return (
    <div
      id="projects"
      className="bg-[#1E1E1E] py-10 pt-16 w-full min-h-screen flex flex-col items-center"
    >
      <h1 className="text-white text-3xl sm:text-4xl lg:text-5xl  px-10 md:pt-16 text-center ">
        these are some of my{" "}
        <span className="text-[#FFCD29] font-semibold">very cool </span>
        projects
      </h1>

      <div className="flex flex-col justify-center gap-40 items-center pt-24 flex-1">
        {projects.map((project) => (
          <section
            key={project.id}
            className="flex flex-col md:flex-row mt-10 gap-10 md:gap-20 justify-around items-center w-full max-w-6xl px-4"
          >
            <div className="text-center order-1 md:order-1 md:pr-10 flex flex-col items-center w-full md:w-1/2">
              <h1 className="text-white text-2xl md:text-4xl font-bold w-full">
                {project.title}
              </h1>
              <br />
              <p className="text-white text-center">{project.description}</p>
              <img
                className={project.skillsImageStyle}
                src={project.skillsImage}
                alt={`${project.title} skills`}
              />
            </div>

            {/* Project Image - appears second on mobile */}
            <div
              onClick={() =>
                project.link && window.open(project.link, "_blank")
              }
              className="border-8 border-[#FFCD29] rounded-lg order-2 md:order-2 h-76 w-full"
            >
              <img
                className="w-full object-cover"
                src={project.projectImage}
                alt={project.title}
              />
            </div>
          </section>
        ))}
      </div>
    </div>
  );
};

export default Project;
